import { AesEncryption } from './encryption';

/**
 * 创建加密存储适配器
 * 使用AES加密算法保护存储在localStorage中的敏感数据
 */
export const createEncryptedStorage = (secretKey: string) => {
  // 为ECB模式生成一个固定的IV（实际上ECB模式不需要IV，但我们的实现需要）
  const fixedIv = secretKey.slice(0, 16).padEnd(16, '0');
  const encryption = new AesEncryption({
    key: secretKey.slice(0, 16).padEnd(16, '0'), // 确保key是16位
    iv: fixedIv,
  });

  return {
    getItem: (name: string): string | null => {
      try {
        const encrypted = localStorage.getItem(name);
        if (!encrypted) return null;

        // 解密数据
        const decrypted = encryption.decryptByAES(encrypted);
        return decrypted || null;
      } catch (error) {
        console.warn(`Failed to decrypt storage item "${name}":`, error);
        // 只有在开发环境才清除数据，生产环境保留以便调试
        if (process.env.NODE_ENV === 'development') {
          localStorage.removeItem(name);
        }
        return null;
      }
    },

    setItem: (name: string, value: string): void => {
      try {
        // 加密数据
        const encrypted = encryption.encryptByAES(value);
        localStorage.setItem(name, encrypted);
      } catch (error) {
        console.error(`Failed to encrypt storage item "${name}":`, error);
        throw error;
      }
    },

    removeItem: (name: string): void => {
      localStorage.removeItem(name);
    },
  };
};

/**
 * 获取加密密钥
 * 优先使用环境变量，如果没有则使用默认密钥（生产环境应该避免）
 */
export const getStorageEncryptionKey = (): string => {
  // 从环境变量获取密钥
  const envKey = process.env.REACT_APP_STORAGE_ENCRYPTION_KEY;

  if (envKey) {
    return envKey;
  }

  // 开发环境警告
  if (process.env.NODE_ENV === 'development') {
    console.warn(
      '⚠️ 使用默认加密密钥。生产环境请设置 REACT_APP_STORAGE_ENCRYPTION_KEY 环境变量。'
    );
  }

  // 默认密钥（仅用于开发环境）
  return 'store-ops-default-key-2024-16bit';
};
